export const DEFAULT_EVENT_TYPES = [
  {
    title: 'Meetup',
    color: '#022B42',
    isResponseRequired: false,
  },
  {
    title: 'Event',
    color: '#DF9213',
    isResponseRequired: false,
  },
  {
    title: 'Meeting',
    color: '#003554',
    isResponseRequired: false,
  },
  {
    title: 'Board Meeting',
    color: '#032030',
    isResponseRequired: false,
  },
  {
    title: 'Trip',
    color: '#004D74',
    isResponseRequired: false,
  },
  {
    title: 'Workshop',
    color: '#006494',
    isResponseRequired: false,
  },
  {
    title: 'Duty / Shift',
    color: '#006DA4',
    isResponseRequired: false,
  },
  {
    title: 'Company Event',
    color: '#022B42',
    isResponseRequired: false,
  },
  {
    title: 'Training',
    color: '#004D74',
    isResponseRequired: false,
  },
  {
    title: 'Tournament',
    color: '#006DA4',
    isResponseRequired: false,
  },
  {
    title: 'Rehearsal',
    color: '#003554',
    isResponseRequired: false,
  },
  {
    title: '🔴 CANCELLED 🔴',
    color: '#7A1A00',
    isResponseRequired: false,
  },
  {
    title: 'INFO',
    color: '#4A90E2',
    isResponseRequired: false,
  },
  {
    title: 'SURVEY',
    color: '#22538D',
    isResponseRequired: false,
  },
];
